import Service from "../Service";
const resource = "email/";

export default {
    sendEmail(parameters, requestID) {
        return Service.post(resource + "sendEmail", parameters, {
            params: { requestID: requestID },
        });
    },
    sendEmailWithAttach(parameters, requestID) {
        return Service.post(resource + "sendEmailWithAttach", JSON.stringify(parameters), {
            params: { requestID: requestID },
            headers: {
                "Content-Type": "application/json",
            },
        });
    },
};